module.exports = __webpack_public_path__ + "img/hd-bg.8dbbbaa6.png";